import { render, staticRenderFns } from "./CarbControl.vue?vue&type=template&id=66fb1b2a&"
import script from "./CarbControl.vue?vue&type=script&lang=js&"
export * from "./CarbControl.vue?vue&type=script&lang=js&"
import style0 from "./CarbControl.vue?vue&type=style&index=0&id=66fb1b2a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports